export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.2 59.6">
    <polygon points="2.5,59.5 0.1,59.5 20.7,29.9 0.1,0.1 2.5,0.1 23.1,29.9" />
  </svg>
);
